import { splitProps } from 'solid-js';
import style from '#src/client/common/elements/Label.module.css';

function Label(props) {
    const [local, others] = splitProps(props, ['class']);

    const classes = () => {
        return [
            local.class,
            style.label,
        ].join(' ');
    };

    return (
        <label
            {...others}
            class={classes()}>{props.children}</label>
    );
}

export default Label;
